import { ViewModel } from './_vm'
import TopStore from './store/_top-store'
import FormStore from './store/_form-store'

/**
 * init // 初期化
 *
 * @returns {undefined}
 */
export class FormStoreCtl extends ViewModel {
  constructor($element, controller) {
    super(FormStoreCtl.name(), $element, controller)
    TopStore.init()

    this.url = this.attr('action', '/')
    this.$element.find('.js-kaigai-form-submit').on('click', () => this.submit())
    this.$errors = this.$element.find('.js-kaigai-form-errors')
    this.on('Form:errors', () => this.error())
  }

  static name() {
    return 'FormStoreCtl'
  }

  static className() {
    return '.js-kaigai-form'
  }

  /**
   * submit // 送信
   */
  submit() {
    this.$errors.empty()
    TopStore.send(this.url)
  }

  error() {
    this.$errors.empty()
    const errors = FormStore.validationErrors()
    Object.values(errors).forEach(value => {
      if (value !== null) this.$errors.append(`<p>${value}</p>`)
    })
  }
}
